import React, { useState } from "react"
import uuid from "react-uuid"
import myInitObject from "../ultis/variable"
import BuilderHalf from "../components/half/builderHalf"
import Hero from "./hero"
import DescriptionImage from "./descriptionImage"
import Managing from "./managing"
import LogoSider from "./logo"
import Services from "./services"
import Feed from "./feed"
import HiddenInfo from "./hiddenInfo"
import LogoNumber from "./logoNumber"
import Quotation from "./quotation"
import PostImage from "./styles/PostImage"
import PostDescription from "./styles/PostDescription"
import ImageDescriptionNumber from "./imageDescriptionNumber"
import RowNumbers from "./rowNumbers"
import PersonSingle from "./personSingle.js"
import FeedJob from "./feedJob.js"
import FeedJobEN from "./feedJobEN"

function selectCompoment(data, pageContext) {
  switch (data.component) {
    case "Half":
      return <BuilderHalf key={uuid()} half={data} />

    case "descriptionImage":
      return <DescriptionImage key={uuid()} data={data} />

    case "heroTitleImage":
      return (
        <Hero
          key={uuid()}
          heading={data.settings.title}
          heroType="text"
          text={data.settings.description}
          img={myInitObject.cockpitUrl + data.settings.image.path}
        />
      )

    case "heroForm":
      return (
        <Hero
          key={uuid()}
          heading={data.settings.heading}
          headingLineColor={data.settings.headingLineColor}
          description={data.settings.description}
          formPlaceholder={data.settings.formPlaceholder}
          formButtonText={data.settings.formButtonText}
          checkboxText={data.settings.checkboxText}
          errorCheckbox={data.settings.errorCheckbox}
          errorInput={data.settings.errorInput}
          heroType="form"
        />
      )

    case "heroCaseStudy":
      return (
        <Hero
          key={uuid()}
          heroType="case"
          heading={data.settings.title}
          text={data.settings.description}
          logo={
            data.settings.logo
              ? myInitObject.cockpitUrl + data.settings.logo.path
              : ""
          }
          img={myInitObject.cockpitUrl + data.settings.image.path}
        />
      )

    case "managing":
      return <Managing key={uuid()} data={data} />

    case "logotype":
      return <LogoSider key={uuid()} />

    case "services":
      return (
        <Services
          key={uuid()}
          heading={data.settings.heading}
          icon={myInitObject.cockpitUrl + data.settings.icon.path}
          iconPosition={data.settings.iconPosition}
          service={data.settings.service}
        />
      )

    case "feed":
      return (
        <Feed
          key={uuid()}
          heading={data.settings.heading}
          icon={myInitObject.cockpitUrl + data.settings.icon.path}
          iconPosition={data.settings.iconPosition}
          column={data.settings.column}
        />
      )

    case "hiddenInfo":
      return (
        <HiddenInfo
          key={uuid()}
          heading={data.settings.heading}
          description={data.settings.description}
          color={data.settings.color}
          showHideInfo={data.settings.showHideInfo}
        />
      )

    case "logoNumber":
      return (
        <LogoNumber
          key={uuid()}
          heading={data.settings.heading}
          textLogo={data.settings.textLogo}
          textBeforeNumber={data.settings.textBeforeNumber}
          logo={data.settings.logo.path}
          number={data.settings.number}
          numberColor={data.settings.numberColor}
          textAfterNumber={data.settings.textAfterNumber}
        />
      )

    case "quotation":
      return (
        <Quotation
          key={uuid()}
          heading={data.settings.heading}
          quoteSign={data.settings.quoteSign.path}
          quotation={data.settings.quotation}
        />
      )

    case "postDescription":
      return (
        <PostDescription key={uuid()} content={data.settings.description} />
      )

    case "postImage":
      return (
        <PostImage
          key={uuid()}
          img={myInitObject.cockpitUrl + data.settings.image.path}
        />
      )

    case "imageDescriptionNumber":
      return <ImageDescriptionNumber key={uuid()} row={data.settings.row} />

    case "numbers":
      return (
        <RowNumbers
          key={uuid()}
          heading={data.settings.heading}
          numbers={data.settings.numbers}
        />
      )

    case "person":
      return (
        <PersonSingle
          key={uuid()}
          email={data.settings.email}
          linkedIn={data.settings.linkedIn}
          img={myInitObject.cockpitUrl + data.settings.img.path}
          quotation={data.settings.quotation}
        />
      )

    case "feedJob":
      if (pageContext.langKey === "en") {
        return <FeedJobEN key={uuid()} heading={data.settings.heading} />
      } else {
        return <FeedJob key={uuid()} heading={data.settings.heading} />
      }

    default:
      return null
  }
}

const Builder = ({ data, pageContext }) => {
  return (
    <>
      {data.map(setcion => {
        return selectCompoment(setcion, pageContext)
      })}
    </>
  )
}

export default Builder
